import find from 'lodash/find';
import { ApiService } from 'services/api.service';
import { ModalService } from 'services/modal.service';

import { SavedPaymentMethod } from './savedPaymentMethod/savedPaymentMethod';
import { AddPaymentMethod } from './addPaymentMethod/addPaymentMethod';
import { OtherPaymentMethodsList } from './otherPaymentMethodsList/otherPaymentMethodsList';

import template from './editAccountPayment.html';
import './editAccountPayment.scss';

export const EditAccountPayment = angular
    .module('checkout.components.editAccountPayment', [
        ApiService,
        ModalService,
        SavedPaymentMethod,
        AddPaymentMethod,
        OtherPaymentMethodsList
    ]).service('editAccountPaymentService', (modalService) => {
        return {
            open: (initialPaymentMethod, stripe, $event) => {
                return modalService.open({
                    $event,
                    template: `
                        <edit-account-payment
                            stripe="stripe"
                            initial-payment-method="initialPaymentMethod"
                            layout="column">
                        </edit-account-payment>
                    `,
                    cssClass: 'edit-account-payment',
                    data: { initialPaymentMethod, stripe }
                });
            }
        };
    }).component('editAccountPayment', {
        bindings: {
            initialPaymentMethod: '<',
            stripe: '<'
        },
        template,
        controller: class EditAccountPaymentController {
            constructor(
                $mdDialog,
                checkoutService,
                apiService,
                $rootScope,
                $q,
                $scope,
                $mdMedia
            ) {
                angular.extend(this, {
                    $mdDialog,
                    checkoutService,
                    apiService,
                    $rootScope,
                    $q,
                    $scope,
                    $mdMedia
                });

                this.onPaymentMethodEdited = this.onPaymentMethodEdited.bind(this);
                this.onPaymentMethodDeleted = this.onPaymentMethodDeleted.bind(this);
                this.onPaymentMethodAdded = this.onPaymentMethodAdded.bind(this);
            }

            $onInit() {
                this.fetchingPaymentMethods = true;

                this.$q.all([
                    this.getAndSetDefaultShippingAddress(),
                    this.getAndSetSavedPaymentMethods(),
                    this.getAndSetAvailablePaymentMethods()
                ]).then(() => {
                    this.selectedPaymentMethod = this.getBestDefault();
                }).finally(() => {
                    this.fetchingPaymentMethods = false;
                });

                this.unbindListener = this.$rootScope.$on('editAccountPayment:Editing', (event, data) => {
                    if (data !== 'newPayment') this.showAddPaymentMethodForm = false;
                });

                this.$scope.$watch(() => this.$mdMedia('xs'), (isXs) => {
                    this.isMobile = isXs;
                });
            }

            $onDestroy() {
                this.unbindListener();
            }

            getBestDefault() {
                let bestDefault;

                if (this.initialPaymentMethod === 'PayPal') {
                    bestDefault = 'PayPal';
                } else {
                    const defaultPaymentMethod = this.getDefaultPaymentMethod();
                    const initialPaymentMethod = find(this.savedPaymentMethods, { id: this.initialPaymentMethod });

                    if (initialPaymentMethod) {
                        bestDefault = initialPaymentMethod.id;
                    } else if (defaultPaymentMethod) {
                        bestDefault = defaultPaymentMethod.id;
                    } else if (this.savedPaymentMethods && this.savedPaymentMethods.length > 0) {
                        bestDefault = this.savedPaymentMethods[0].id;
                    }
                }

                return bestDefault;
            }

            onConfirmClicked() {
                const returnData = this.selectedPaymentMethod === 'PayPal' ?
                    'PayPal' : find(this.savedPaymentMethods, { id: this.selectedPaymentMethod });
                this.$mdDialog.hide(returnData);
            }

            getAndSetSavedPaymentMethods() {
                return this.apiService.account.paymentMethod.getAll()
                    .then((paymentMethods) => {
                        this.savedPaymentMethods = paymentMethods.items;
                        return paymentMethods;
                    }).catch((err) => {
                        if (err.status !== 400) { // If Stripe is disabled
                            return this.$q.reject(err);
                        }
                    });
            }

            getAndSetAvailablePaymentMethods() {
                return this.checkoutService.getAvailablePaymentMethods().then((availablePaymentMethods) => {
                    return this.otherPaymentMethods = availablePaymentMethods.filter(method => method.type === 'other');
                });
            }

            getAndSetDefaultShippingAddress() {
                return this.apiService.account.shippingAddress.getAll()
                    .then((shippingAddresses) => {
                        const defaultShippingAddress = find(shippingAddresses.items, 'address.isDefault');
                        if (defaultShippingAddress) {
                            this.defaultShippingAddress = defaultShippingAddress.address;
                        }
                        return this.defaultShippingAddress;
                    });
            }

            onAddPaymentMethodClicked() {
                this.showAddPaymentMethodForm = true;
                this.selectedPaymentMethod = 'new';
                this.$rootScope.$emit('editAccountPayment:Editing', 'newPayment');
            }

            onCancelAddClicked() {
                this.showAddPaymentMethodForm = false;
                this.selectedPaymentMethod = this.getBestDefault();
            }

            onPaymentMethodAdded(paymentMethod) {
                return this.getAndSetSavedPaymentMethods().then(() => {
                    this.selectedPaymentMethod = paymentMethod.id;
                    this.showAddPaymentMethodForm = false;
                });
            }

            onPaymentMethodEdited() {
                return this.getAndSetSavedPaymentMethods();
            }

            onPaymentMethodDeleted() {
                return this.getAndSetSavedPaymentMethods().then(() => {
                    this.selectedPaymentMethod = this.getBestDefault();
                });
            }

            cancel() {
                this.$mdDialog.cancel();
            }

            shouldShowDeleteButton() {
                return this.savedPaymentMethods && this.savedPaymentMethods.length > 1;
            }

            getDefaultPaymentMethod() {
                return find(this.savedPaymentMethods, 'isDefault');
            }

            shouldConfirmButtonBeDisabled() {
                return this.isUpdatingCart
                    || !this.selectedPaymentMethod
                    || this.selectedPaymentMethod === 'new';
            }
        }
    }).name;



// WEBPACK FOOTER //
// ./src/app/components/editAccountPayment/editAccountPayment.js